<template>
  <div>
    <report-header @generate="load" @filterChanged="filterChanged"
      @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd" @onChangedGroup="onChangedGroup"
      :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"
        @limitChanged="limitChanged"
        @download="download"
        @onChangeAccsGroup="onChangeAccsGroup"
        @isAlternativeDateChanged="isAlternativeDateChanged"/>

    <basic-table
      @Filtred="Filtred"
      :items="telephony"
      :fields="telephonyFields"
      :filter="filter"
      :per-page="perPage"
      :current-page="currentPage"
      :totalRows="totalRows"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
  </div>
</template>

<script>
import moment from 'moment'
import download from '@/utils/downloadFile'
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        group_id: 0,
        accs_group_id: 0,
        limit: 500,
        download: 0,
        isAlternativeDate: false
      },
      telephony: [],
      telephonyFields: [
        {key: 'id', label: this.$i18n.t('Session ID'), sortable: true},
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'recv_date', label: this.$i18n.t('Receive date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'setup_time', label: this.$i18n.t('Start date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'endTime', label: this.$i18n.t('End date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'called_station_id', label: this.$i18n.t('Called station'), sortable: true},
        {key: 'calling_station_id', label: this.$i18n.t('Calling station'), sortable: true},
        {key: 'nas_port', label: this.$i18n.t('NAS port'), sortable: true},
        {key: 'acct_session_id', label: this.$i18n.t('NAS session ID'), sortable: true},
        {key: 'uname', label: this.$i18n.t('Login'), sortable: true},
        {key: 'nas_ip', label: 'NAS IP', sortable: true},
        {key: 'status', label: this.$i18n.t('Status'), sortable: true},
        {key: 'zone_id', label: this.$i18n.t('Zone'), sortable: true},
        {key: 'dir_id', label: this.$i18n.t('Direction'), sortable: true},
        {key: 'duration', label: this.$i18n.t('Duration (rounded off)'), sortable: true},
        {key: 'acct_sess_time', label: this.$i18n.t('Duration'), sortable: true},
        {key: 'incoming_trunk', label: this.$i18n.t('Incoming trunk'), sortable: true},
        {key: 'outgoing_trunk', label: this.$i18n.t('Outcoming trunk'), sortable: true},
        {key: 'pbx_id', label: this.$i18n.t('PBX ID'), sortable: true},
        {key: 'base_cost', label: this.$i18n.t('Cost per unit'), sortable: true},
        {key: 'sum_cost', label: this.$i18n.t('Total cost'), sortable: true},
        {key: 'h323_disconnect_cause', label: this.$i18n.t('Disconnect cause'), sortable: true},
        {key: 'cost_mult', label: this.$i18n.t('Cost multiplication factor'), sortable: true},
        {key: 'telFlags', label: this.$i18n.t('Telephony Dialup/VPN Flags'), sortable: true}
      ],
      isGenerateDisabled: false,
      selectGroup: 0,
      selectAccsGroup: 0,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      filterOptions: {
        isFilterGroup: true,
        isFilterAccsGroup: true,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false,
        isDownloadable: true,
        hasLimitRows: true,
        isTelephonyReport: true
      },
      isAlternativeDate: false
    }
  },
  methods: {
    Filtred (items) {
      this.totalRows = items.length
    },
    async load (isGenClicked = true) {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart

      if (!this.userId) {
        this.getStore.group_id = this.selectGroup
        this.getStore.accs_group_id = this.selectAccsGroup
      } else {
        this.getStore.userId = this.userId
      }
      this.getStore.isAlternativeDate = this.isAlternativeDate
      await this.$store.dispatch('Reports/GET_TELEPHONY', this.getStore).then(response => {
        if (isGenClicked) {
          this.telephony = this.$store.getters['Reports/TELEPHONY']
        } else {
          download(this.$store.getters['Reports/TELEPHONY'], 'report_services_telephony.csv', 'text/csv')
        }
        for (let el of this.telephony) {
          el.endTime = moment(Number(el.setup_time + el.duration) * 1000).unix()
          if (!el.zone_id) {
            el.zone_id = '---'
          }
          if (!el.nas_ip) {
            el.nas_ip = '0.0.0.0'
          }
          switch (el.acct_status_type) {
            case 1:
              el.status = this.$i18n.t('Session start')
              break
            case 2:
              el.status = this.$i18n.t('Session stop')
              break
            case 3:
              el.status = this.$i18n.t('Session update')
              break
          }
          switch (el.flags) {
            case 1:
              el.telFlags = this.$i18n.t('Ignore session time')
              break
            case 2:
              el.telFlags = this.$i18n.t('Dropped')
              break
            case 4:
              el.telFlags = this.$i18n.t('Zero charge')
              break
            case 8:
              el.telFlags = this.$i18n.t('ISG session')
              break
          }
        }
      })
      this.loadDone()
      this.totalRows = this.telephony.length
      this.$emit('input', this.totalRows)
    },
    download () {
      this.getStore.download = 1
      this.load(false)
      this.$store.dispatch('Reports/CLEAR_TEL')
      this.getStore.download = 0
      this.totalRows = 0
      this.telephony = []
    },
    limitChanged (limit) {
      this.getStore.limit = limit
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedGroup (value) {
      this.selectGroup = (value)
    },
    onChangeAccsGroup (value) {
      this.selectAccsGroup = value
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    },
    isAlternativeDateChanged (val) {
      this.isAlternativeDate = val
    }
  },
  mounted () {
    this.loadDone()
    if (this.userId) {
      this.filterOptions.isFilterGroup = false
      this.filterOptions.isFilterAccsGroup = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/services/telephony/main.vue